import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import api from "../lib/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUserAfterAuth } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUserAfterAuth(data);
        window.history.replaceState(null, "", window.location.pathname);
        const role = data?.role;
        const validRole = ["player", "academy_agent", "pro_team"].includes(role);
        const business = ["academy_agent", "pro_team"].includes(role);
        const activeSub = data?.subscription && ["trialing", "active"].includes(data.subscription.status);
        if (data?.is_admin) {
          navigate("/dashboard");
        } else if (!validRole) {
          navigate("/onboarding");
        } else if (business && !activeSub) {
          navigate("/pricing");
        } else {
          navigate("/dashboard");
        }
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUserAfterAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#08090b]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-gray-400 text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
